import React from 'react';
import { useTranslation } from 'react-i18next';
import { OPEN_SHIPMENT_OPTIONS } from '../../../../interfaces/sendReceipt/sendReceiptMultistep';
import FormikFieldWrapper from '../../../base/forms/formikFieldWrapper';
import FormikRadio from '../../../base/forms/formikRadio';
import { A } from '../../../base/typography';
import { useMultiStepFormContext } from '../../context/multistepContext';
import { useTranslationsContext } from '../../context/translationsContext';
import { FormStepProps } from '../../sendReceiptMultistep';
import {
	ButtonWrapper,
	FormStepHeading,
	Label,
	PrevButton,
	PrevButtonMobile,
	ProceedButton,
} from '../../sendReceiptMultistep.styles';
import { SEPARATOR_CHAR } from './InstructionToStaff';
import * as StyledInstructionToStaff from './InstructionToStaff.styles';

const OPEN_SHIPMENT_OPTIONS_MAX_LENGTH = Math.max(...OPEN_SHIPMENT_OPTIONS.map(option => option.length));

export default function OpenShipment({ values, errors, setFieldValue }: FormStepProps) {
	const translations = useTranslationsContext();
	const { prev } = useMultiStepFormContext();
	const { t } = useTranslation('sendReceiptMultistep');

	const isStepComplete = values.openUp && !errors.openUp && !errors.additionalInformation;

	return (
		<>
			<PrevButtonMobile
				onClick={e => {
					e.stopPropagation();
					prev();
				}}>
				{translations?.prevStepMobile || t('prevStepMobile')}
			</PrevButtonMobile>
			<FormStepHeading>
				{translations?.formStepTitles?.type?.openUp || t('formStepTitles.type.openUp')}
			</FormStepHeading>
			<StyledInstructionToStaff.FieldWrapper>
				<FormikFieldWrapper name="openUp" languageComponent="sendReceipt">
					<FormikRadio
						id={OPEN_SHIPMENT_OPTIONS[0]}
						name="openUp"
						label={translations?.openUp.option1 || t('openUp.option1')}
						setFieldValue={setFieldValue}
					/>
					<FormikRadio
						id={OPEN_SHIPMENT_OPTIONS[1]}
						name="openUp"
						label={
							<>
								{translations?.openUp?.option2 || t('openUp.option2')}
								<A blank to={`${translations?.openUp?.termsLink || t('openUp.termsLink')}`}>
									{translations?.openUp?.terms || t('openUp.terms')}
								</A>
							</>
						}
						setFieldValue={setFieldValue}
					/>
				</FormikFieldWrapper>
			</StyledInstructionToStaff.FieldWrapper>
			<Label>{translations?.description || t('description')}</Label>
			<StyledInstructionToStaff.TextArea
				maxLength={254 - OPEN_SHIPMENT_OPTIONS_MAX_LENGTH - SEPARATOR_CHAR.length}
				type="text"
				id="additionalInformation"
				name="additionalInformation"
				component="textarea"
				padding="1rem"
				placeholder={`${translations?.descriptionPlaceholder || t('descriptionPlaceholder')}`}
			/>
			<ButtonWrapper>
				<PrevButton
					onClick={e => {
						e.stopPropagation();
						prev();
					}}>
					{translations?.prevStep || t('prevStep')}
				</PrevButton>
				<ProceedButton type="submit" disabled={!isStepComplete}>
					{translations?.submit || t('submit')}
				</ProceedButton>
			</ButtonWrapper>
		</>
	);
}
